import PropTypes from "prop-types"
import React, { FC, ImgHTMLAttributes } from "react"
import { Box } from "@carrotfertility/carotene-core"

type CircleImageProps = {
  src: string
  srcSet?: string
  backgroundColor?: string
  size?: number
  padding?: number
} & ImgHTMLAttributes<HTMLImageElement>

const CircleImage: FC<CircleImageProps> = ({ src, srcSet, size = 40, padding = 8 }) => {
  const imageSize = size - padding * 2
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius={(theme) => theme.tokens.borderRadius.round}
      height={size}
      width={size}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper
      })}
    >
      <img src={src} srcSet={srcSet} height={imageSize} width={imageSize} alt="" />
    </Box>
  )
}

CircleImage.propTypes = {
  src: PropTypes.string.isRequired
}

export { CircleImage }
